import NotFoundPageModel from 'Models/Pages/NotFoundPage/NotFoundPageModel.interface';
import { styled } from 'stitches.config';
import useCurrentPage from 'Shared/Hooks/useCurrentPage';
import useMedia from 'Shared/Hooks/useMedia';
import { applyEditModeAttr, canUseDOM } from 'Shared/Common/Helpers';
import { mediaQueryTypes } from 'Theme/Settings/mediaQueries';
import { H1, H6 } from 'Atoms/Typography/Headings/Heading';
import ContentContainer from 'Molecules/ContentContainer/ContentContainer';
import XHtmlArea from 'Molecules/XHtmlArea/XHtmlArea';
import IconLink from 'Atoms/Links/IconLink';
import { useTranslationData } from 'Shared/Providers/TranslationProvider';

function NotFoundPage() {
  const isDesktop = useMedia(mediaQueryTypes.mediaMinMedium);

  const {
    image,
    mobileImage,
    heading,
    subheading,
    bodyText,
    inEditMode,
    links,
  } = useCurrentPage<NotFoundPageModel>();

  const {
    errorLabels: { errorCode },
  } = useTranslationData();

  const currentUrl = canUseDOM() ? window.location.href : '';

  const modifiedSubHeading = subheading?.replace('{url}', currentUrl);

  return (
    <NotFound
      css={{
        backgroundImage: `url(${isDesktop ? image?.src : mobileImage?.src})`,
      }}
    >
      <ContentContainer>
        <H6 noMargin css={{ mb: 1 }}>
          {errorCode?.toUpperCase()} 404
        </H6>
        <H1 noMargin css={{ mb: 12 }}>
          {heading}
        </H1>
        <ParagraphContainer>
          <XHtmlArea
            content={modifiedSubHeading}
            {...applyEditModeAttr(inEditMode && 'SubHeading')}
          />
        </ParagraphContainer>
        <ParagraphContainer>
          <XHtmlArea
            content={bodyText}
            {...applyEditModeAttr(inEditMode && 'BodyText')}
          />
        </ParagraphContainer>
        {links && links.length > 0 && (
          <Links>
            <IconLink href={links[0].href}>{links[0].text}</IconLink>
            <IconLink href={links[1].href}>{links[1].text}</IconLink>
          </Links>
        )}
      </ContentContainer>
    </NotFound>
  );
}

const NotFound = styled('div', {
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  aspectRatio: '1',
  width: '100%',
  pt: 40,
  pb: 24,
  '@mediaMinLarge': {
    backgroundSize: 'cover',
    aspectRatio: '16/9',
    pt: 23,
  },
});

const ParagraphContainer = styled('div', {
  mb: 7,
  color: '$secondary2',
  maxW: '526px',
});

const Links = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  '@mediaMinLarge': {
    gap: 16,
  },
});

export default NotFoundPage;
